import { getCookie } from './src-utils-app-utils.js';
import { util } from './src-utils-miaw-common.js';

const CHATBOT_REST_ID = "CHATBOT_REST_ID";
const CHATBOT_REST_COUNTER = "CHATBOT_REST_COUNTER";
const getRestId = (increaseCounter = true) => {
  if (typeof window === "undefined") return "";
  setRestId();
  const id = window?.localStorage?.getItem(CHATBOT_REST_ID) || "";
  const numberId = window?.localStorage?.getItem(CHATBOT_REST_COUNTER);
  let restCounter = Number(numberId);
  if (increaseCounter) {
    restCounter += 1;
    window?.localStorage?.setItem(CHATBOT_REST_COUNTER, restCounter.toString());
  }
  return `${id}_${restCounter}`;
};
const getRestIdWithoutCounter = () => {
  if (typeof window === "undefined") return "";
  setRestId();
  const id = window?.localStorage?.getItem(CHATBOT_REST_ID) || "";
  return id;
};
const setRestId = () => {
  if (typeof window === "undefined") return;
  let id = window?.localStorage?.getItem(CHATBOT_REST_ID) || "";
  if (!id) {
    id = util.generateUUID();
  }
  let restCounter = Number(localStorage.getItem(CHATBOT_REST_COUNTER));
  if (isNaN(Number(restCounter))) {
    restCounter = 1;
  }
  window?.localStorage?.setItem(CHATBOT_REST_ID, id);
  window?.localStorage?.setItem("CHATBOT_REST_COUNTER", restCounter.toString());
};
const clearRestId = () => {
  if (typeof window === "undefined") return;
  window?.localStorage?.removeItem(CHATBOT_REST_ID);
  window?.localStorage?.removeItem(CHATBOT_REST_COUNTER);
};
const CHATBOT_TOKEN_KEY = "chatbotToken";
const setChatbotToken = (token, isSignedIn) => {
  if (typeof window === "undefined") return;
  window?.localStorage?.setItem(CHATBOT_TOKEN_KEY, token);
  setIsUserLoggedInAtChatStart(isSignedIn);
};
const getChatbotToken = () => {
  if (typeof window === "undefined") {
    console.warn("Chatbot token not found in local storage.");
    return "";
  }
  const token = window?.localStorage?.getItem(CHATBOT_TOKEN_KEY);
  if (!token) {
    console.warn("Chatbot token not found in local storage.");
  }
  return token;
};
const clearChatbotToken = () => {
  if (typeof window === "undefined") return;
  window?.localStorage?.removeItem(CHATBOT_TOKEN_KEY);
  clearIsUserLoggedInAtChatStart();
};
const setIsUserLoggedInAtChatStart = (isLoggedIn) => {
  if (typeof window === "undefined") return;
  window?.localStorage?.setItem("CHAT_USER_LOGGED_IN", JSON.stringify(isLoggedIn));
};
const getIsUserLoggedInAtChatStart = () => {
  if (typeof window === "undefined") return "false";
  const value = window?.localStorage?.getItem("CHAT_USER_LOGGED_IN");
  return value || "false";
};
const clearIsUserLoggedInAtChatStart = () => {
  if (typeof window === "undefined") return;
  window?.localStorage?.removeItem("CHAT_USER_LOGGED_IN");
};
const CHAT_SESSION_KEY = "chatSession";
const getChatSessionType = () => {
  if (typeof window === "undefined") return "initial";
  const chatSession = window?.localStorage?.getItem(CHAT_SESSION_KEY);
  if (chatSession === "miawChatSession" || chatSession === "chatbotSession") {
    return chatSession;
  }
  return "initial";
};
const setChatSessionType = (sessionType) => {
  if (typeof window === "undefined") return;
  window?.localStorage?.setItem(CHAT_SESSION_KEY, sessionType);
};
const clearChatSessionType = () => {
  if (typeof window === "undefined") return;
  window?.localStorage?.removeItem(CHAT_SESSION_KEY);
};
const CHAT_WINDOW_STATE_KEY = "chatWindowState";
const setChatWindowState = (state) => {
  if (typeof window === "undefined") return;
  window?.localStorage?.setItem(CHAT_WINDOW_STATE_KEY, state);
};
const getChatWindowState = () => {
  if (typeof window === "undefined") return "minimized";
  const state = window?.localStorage?.getItem(CHAT_WINDOW_STATE_KEY);
  return state === "maximized" ? "maximized" : state === "hidden" ? "hidden" : "minimized";
};
const clearChatWindowState = () => {
  if (typeof window === "undefined") return;
  window?.localStorage?.removeItem(CHAT_WINDOW_STATE_KEY);
};
const setPreChatInfoLocalStorage = (userInfo) => {
  if (typeof window === "undefined") return;
  window?.localStorage?.setItem("MIAW_PRE_CHAT_USER_INFO", JSON.stringify(userInfo));
};
const getPreChatInfoFromLocalStorage = () => {
  if (typeof window === "undefined") return null;
  const userInfo = window?.localStorage?.getItem("MIAW_PRE_CHAT_USER_INFO");
  const userObject = userInfo ? JSON.parse(userInfo) : null;
  return userObject;
};
const clearPreChatInfoFromLocalStorage = () => {
  if (typeof window === "undefined") return;
  window?.localStorage?.removeItem("MIAW_PRE_CHAT_USER_INFO");
};
const setIsSendRoutingAttributes = (value) => {
  if (typeof window === "undefined") return;
  window?.localStorage?.setItem("MIAW_SEND_ROUTING_ATTRIBUTES", JSON.stringify(value));
};
const getIsSendRoutingAttributes = () => {
  if (typeof window === "undefined") return false;
  const value = window?.localStorage?.getItem("MIAW_SEND_ROUTING_ATTRIBUTES");
  const parsedValue = value ? value === "true" : false;
  return parsedValue;
};
const setUnreadCount = (count) => {
  if (typeof window === "undefined") return;
  window?.localStorage?.setItem("CHAT_UNREAD_COUNT", count.toString());
};
const getUnreadCount = () => {
  if (typeof window === "undefined") return 0;
  const count = window?.localStorage?.getItem("CHAT_UNREAD_COUNT");
  return count ? Number(count) : 0;
};
const getChatbotEnv = () => {
  if (typeof window === "undefined") return "dev";
  const pageURL = window.location.href;
  if (pageURL.includes("localhost") || pageURL.includes("staging")) return "dev";
  const cookieValue = getCookie("chatbot-test");
  if (cookieValue === "staging") return "staging";
  if (cookieValue === "dev" || cookieValue === "development") return "dev";
  return "prod";
};
const getMIAWEnv = () => {
  if (typeof window === "undefined") return "sandbox";
  const pageURL = window.location.href;
  if (pageURL.includes("localhost") || pageURL.includes("staging")) return "sandbox";
  const cookieValue = getCookie("miaw-test");
  if (cookieValue === "devs" || cookieValue === "development") return "devs";
  if (cookieValue === "sandbox") return "sandbox";
  return "production";
};

export { clearChatSessionType, clearChatWindowState, clearChatbotToken, clearIsUserLoggedInAtChatStart, clearPreChatInfoFromLocalStorage, clearRestId, getChatSessionType, getChatWindowState, getChatbotEnv, getChatbotToken, getIsSendRoutingAttributes, getIsUserLoggedInAtChatStart, getMIAWEnv, getPreChatInfoFromLocalStorage, getRestId, getRestIdWithoutCounter, getUnreadCount, setChatSessionType, setChatWindowState, setChatbotToken, setIsSendRoutingAttributes, setIsUserLoggedInAtChatStart, setPreChatInfoLocalStorage, setRestId, setUnreadCount };
//# sourceMappingURL=src-utils-session-storage-utils.js.map
